/* eslint-disable @typescript-eslint/no-explicit-any*/
import { Form, Select } from "antd";

export function FormSelect({
  id,
  name = "",
  label = "",
  options,
  placeholder = "Select an option",
  required,
  widthSize = "large",
  rules,
  mode,
  ...rest
}: any) {
  const widthPercentage: string = (() => {
    switch (widthSize.toLowerCase()) {
      case "medium":
        return "75%";
      case "small":
        return "50%";
      default:
        return "100%";
    }
  })();
  return (
    <Form.Item label={label} name={name} rules={rules} layout="vertical">
      <Select
        showSearch
        optionFilterProp="label"
        placeholder={placeholder}
        options={options}
        {...rest}
        style={{ width: widthPercentage }}
        mode={mode}
      />
    </Form.Item>
  );
}
